import { isValidElement, type MouseEvent, type ReactNode } from "react";

// The legacy Radix ToastProvider is rendered without a duration, so Radix
// falls back to its own 5 second default for a zero or missing duration.
// Sonner would fall back to 4 seconds instead.
const RADIX_DEFAULT_DURATION_MS = 5000;

type LegacyToastActionProps = {
  altText?: string;
  children?: ReactNode;
  onClick?: (event: MouseEvent<HTMLButtonElement>) => void;
};

export type SonnerToastAction = {
  label: ReactNode;
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
};

export function toSonnerDuration(duration: number | undefined): number {
  if (duration === undefined || duration === 0 || Number.isNaN(duration)) {
    return RADIX_DEFAULT_DURATION_MS;
  }
  return duration;
}

// Legacy callers pass a Radix <ToastAction> element. Rendering it outside a
// Radix toast loses its built-in close behaviour, so convert it into a Sonner
// action that runs the caller's handler and then closes the legacy toast,
// unless the handler called preventDefault (matching Radix).
export function toSonnerAction(
  action: unknown,
  close: () => void,
): SonnerToastAction | undefined {
  if (!isValidElement<LegacyToastActionProps>(action)) return undefined;
  const { altText, children, onClick } = action.props;
  return {
    label: children ?? altText,
    onClick: (event) => {
      onClick?.(event);
      if (!event.defaultPrevented) close();
    },
  };
}
